import { Seo } from "@/components/Seo/Seo";
import { Reveal } from "@/components/Reveal/Reveal";
import { Parallax } from "@/components/Motion/Parallax";
import { InquiryForm } from "@/components/Forms/InquiryForm";
import { SITE, PARTNERS } from "@/config/site";
import { FEATURED } from "@/data/featured";
import { mediaUrl } from "@/lib/media";
import { breadcrumbJsonLd } from "@/lib/structuredData";
import styles from "./Contact.module.css";

export function ContactPage() {
  return (
    <>
      <Seo
        title="Contact"
        description="Get in touch with the Villa Rosa team about overnight stays, events, or questions about our Fallbrook, CA estate."
        path="/contact"
        jsonLd={breadcrumbJsonLd([
          { name: "Home", path: "/" },
          { name: "Contact", path: "/contact" },
        ])}
      />

      <header className={styles.hero}>
        <Parallax
          speed={0.12}
          className={styles.heroMedia}
          style={{ backgroundImage: `url(${mediaUrl(FEATURED.frontHome)})` }}
        >
          <span />
        </Parallax>
        <div className={styles.heroScrim} />
        <div className={`container ${styles.heroInner}`}>
          <p className={`eyebrow eyebrow--rule ${styles.heroEyebrow}`}>Contact</p>
          <h1 className={styles.heroTitle}>Let&rsquo;s start a conversation.</h1>
          <p className={styles.heroLede}>
            Questions about a stay, an event, or the area? Send us a note and
            we&rsquo;ll get back to you as soon as we can.
          </p>
        </div>
      </header>

      <section className="section">
        <div className={`container ${styles.layout}`}>
          <Reveal as="div" variant="left" className={styles.info}>
            <dl className={styles.details}>
              <div>
                <dt>Email</dt>
                <dd>
                  <a href={`mailto:${SITE.email}`}>{SITE.email}</a>
                </dd>
              </div>
              <div>
                <dt>Location</dt>
                <dd>Fallbrook, California · North San Diego County</dd>
              </div>
              <div>
                <dt>Book with</dt>
                <dd>
                  <a href={PARTNERS.airbnb} target="_blank" rel="noopener noreferrer">
                    Airbnb
                  </a>
                  {" · "}
                  <a href={PARTNERS.vrbo} target="_blank" rel="noopener noreferrer">
                    Vrbo
                  </a>
                </dd>
              </div>
            </dl>
          </Reveal>

          <Reveal as="div" variant="right" delay={120} className={styles.formCard}>
            <InquiryForm
              type="contact"
              extras="subject"
              submitLabel="Send message"
              successTitle="Message sent!"
              successBody="Thanks for reaching out. We'll get back to you as soon as possible."
            />
          </Reveal>
        </div>
      </section>
    </>
  );
}
